import type { CreateFunctionInput } from '@gonfalon/legacy-immutable/immutableUtils';

import type { RawProjectPaginatedRep, RawProjectRep } from '#utils/projects/projectTypes';

export function formatPaginatedProjects(
  projects: Array<CreateFunctionInput<RawProjectPaginatedRep>>,
): Array<CreateFunctionInput<RawProjectRep>> {
  const paginatedProjects: Array<CreateFunctionInput<RawProjectRep>> = projects.map(
    (project: CreateFunctionInput<RawProjectPaginatedRep>) => ({
      ...project,
      environments: project?.environments?.items,
      environmentsTotalCount: project?.environments?.totalCount,
    }),
  );
  return paginatedProjects;
}
